import { Box, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue, GeneralIllnessExamData } from '@hb/shared'

const FIELD_LABELS: Record<keyof GeneralIllnessExamData, string> = {
  generalAppearance: 'General Appearance / Affect',
  throatOropharynx: 'Throat / Oropharynx',
  lymphNodes: 'Lymph Nodes',
  lungAuscultation: 'Lung Auscultation',
  hydrationStatus: 'Hydration Status',
  painScale: 'Pain Scale (0–10)',
}

const TEXT_FIELD_ORDER: (keyof Omit<GeneralIllnessExamData, 'painScale'>)[] = [
  'generalAppearance',
  'throatOropharynx',
  'lymphNodes',
  'lungAuscultation',
  'hydrationStatus',
]

export const GeneralIllnessExamView = ({ data }: { data: FieldMapValue }) => {
  const exam = data?.generalIllnessExam as GeneralIllnessExamData | undefined

  const hasAnyValue = exam && (TEXT_FIELD_ORDER.some(k => exam[k]) || exam.painScale != null)

  if (!hasAnyValue) {
    return (
      <Text fontSize="sm" fontStyle="italic" color="gray.400">
        No general illness exam documented.
      </Text>
    )
  }

  return (
    <VStack align="stretch" spacing={3} w="100%">
      {TEXT_FIELD_ORDER.map(key => {
        const val = exam?.[key]
        if (!val) return null
        return (
          <Box key={key}>
            <Text fontSize="xs" fontWeight={600} color="gray.500" mb={0.5}>
              {FIELD_LABELS[key]}
            </Text>
            <Text fontSize="sm" whiteSpace="pre-wrap">
              {val}
            </Text>
          </Box>
        )
      })}
      {exam?.painScale != null && (
        <Box>
          <Text fontSize="xs" fontWeight={600} color="gray.500" mb={0.5}>
            {FIELD_LABELS.painScale}
          </Text>
          <Text fontSize="sm">{exam.painScale} / 10</Text>
        </Box>
      )}
    </VStack>
  )
}
